export enum TicketStatus {
  WAITING = 'WAITING',
  CALLED = 'CALLED',
  SERVED = 'SERVED',
  EXPIRED = 'EXPIRED',
  NO_SHOW = 'NO_SHOW',
  CANCELLED = 'CANCELLED',
  SKIPPED = 'SKIPPED',
}

export enum TicketSource {
  KIOSK = 'KIOSK',
  ONLINE = 'ONLINE',
}

export enum StaffRole {
  ADMIN = 'ADMIN',
  FRONT_DESK = 'FRONT_DESK',
  PROVIDER = 'PROVIDER',
}

export enum FacilityType {
  CLINIC = 'CLINIC',
  HOSPITAL = 'HOSPITAL',
  DIAGNOSTIC_CENTER = 'DIAGNOSTIC_CENTER',
  PHARMACY = 'PHARMACY',
}

export enum DeptType {
  OPD = 'OPD',
  LABORATORY = 'LABORATORY',
  PHARMACY = 'PHARMACY',
  RADIOLOGY = 'RADIOLOGY',
  EMERGENCY = 'EMERGENCY',
  SPECIALTY = 'SPECIALTY',
  EYE = 'EYE',
  DENTAL = 'DENTAL',
}

export enum BookingStatus {
  PENDING = 'PENDING',
  TICKETED = 'TICKETED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
}

export enum QueueDispatch {
  FIFO = 'FIFO',
  PRIORITY = 'PRIORITY',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

export enum ParamDataType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  BOOLEAN = 'BOOLEAN',
  DECIMAL = 'DECIMAL',
  JSON = 'JSON',
}

export enum ParamCategory {
  QUEUE = 'QUEUE',
  NOTIFICATIONS = 'NOTIFICATIONS',
  SECURITY = 'SECURITY',
  APP = 'APP',
}

export const VALID_TICKET_TRANSITIONS: Record<TicketStatus, TicketStatus[]> = {
  [TicketStatus.WAITING]: [
    TicketStatus.CALLED,
    TicketStatus.EXPIRED,
    TicketStatus.CANCELLED,
  ],
  [TicketStatus.CALLED]: [
    TicketStatus.SERVED,
    TicketStatus.NO_SHOW,
    TicketStatus.SKIPPED,
  ],
  [TicketStatus.SKIPPED]: [TicketStatus.CALLED],
  [TicketStatus.SERVED]: [],
  [TicketStatus.EXPIRED]: [],
  [TicketStatus.NO_SHOW]: [],
  [TicketStatus.CANCELLED]: [],
};
